import { getCurrentUser } from './store-service';

const permissions = {
    editBilling: ['owner'],

    owner: ['owner'],

    fullAccess: ['owner', 'super admin'],

    // Team
    editTeam: ['owner', 'super admin'],
    inviteToTeam: ['owner', 'super admin', 'manager'],
    removeFromTeam: ['owner', 'super admin'],
    viewTeamClients: ['owner', 'super admin'],
    viewTeamSettings: ['owner', 'super admin', 'manager', 'regular'],
    viewTeamOverview: ['owner', 'super admin', 'manager', 'regular'],
    leaveTeam: ['manager', 'regular', 'client'],
    editCustomFields: ['owner', 'super admin', 'manager', 'regular'],
    removeCustomFields: ['owner', 'super admin', 'manager', 'regular'],
    viewAllTasks: ['owner', 'super admin', 'manager', 'regular'],
    seeUpgradeFeatures: ['owner', 'super admin', 'manager', 'regular'],

    // User
    editRole: ['owner', 'super admin', 'manager'],
    viewUserActivity: ['owner', 'super admin', 'manager', 'regular'],

    // Subteam
    createSubteam: ['owner', 'super admin', 'manager'],
    editSubteam: ['owner', 'super admin', 'manager'],
    viewSubteam: ['owner', 'super admin', 'manager', 'regular'],
    removeSubteam: ['owner', 'super admin', 'manager'],
    inviteToSubteam: ['owner', 'super admin', 'manager'],
    removeFromSubteam: ['owner', 'super admin', 'manager'],

    // Project
    createProject: ['owner', 'super admin', 'manager', 'regular'],
    editProject: ['owner', 'super admin', 'manager', 'custom'], // owner
    removeProject: ['owner', 'super admin', 'manager', 'custom'], // owner
    inviteToProject: ['owner', 'super admin', 'manager', 'custom'], // owner
    removeFromProject: ['owner', 'super admin', 'manager', 'custom'], // owner
    viewProjectClients: ['owner', 'super admin', 'manager', 'custom'], // owner
    viewProjectSettings: ['owner', 'super admin', 'manager', 'regular', 'custom'], // invitees
    createProjectTemplate: ['owner', 'super admin', 'manager', 'regular'],

    // Milestone
    createMilestone: ['owner', 'super admin', 'manager', 'regular'],
    editMilestone: ['owner', 'super admin', 'manager', 'regular'],
    removeMilestone: ['owner', 'super admin', 'manager', 'regular'],
    publicShareMilestones: ['owner', 'super admin', 'manager', 'regular'],

    // Task group
    createTaskGroup: ['owner', 'super admin', 'manager', 'regular'],
    editTaskGroup: ['owner', 'super admin', 'manager', 'regular'],
    removeTaskGroup: ['owner', 'super admin', 'manager', 'regular'],

    // Task
    createTask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editTask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    hideTask: ['owner', 'super admin', 'manager', 'regular'],
    removeTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // self
    assignToTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // self
    unassignFromTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // self
    publicShareTasks: ['owner', 'super admin', 'manager', 'regular'],

    // Subtask
    createSubtask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editSubtask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    removeSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    assignToSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    unassignFromSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],

    // File
    addFile: ['owner', 'super admin', 'manager', 'regular', 'client'],
    removeFile: ['owner', 'super admin', 'manager', 'custom'], // own files

    // Doc
    createDoc: ['owner', 'super admin', 'manager', 'regular', 'client'],

    // Chat
    viewChat: ['owner', 'super admin', 'manager', 'regular'],
    pinMessage: ['owner', 'super admin', 'manager', 'regular'],

    // Time Tracking
    viewTimeReports: ['owner', 'super admin', 'manager', 'custom'], // own reports
    getUserReport: ['owner', 'super admin', 'manager', 'custom'], // own reports
    getProjectReport: ['owner', 'super admin', 'manager', 'custom'], // own reports
    getTeamReport: ['owner', 'super admin', 'manager', 'custom'], // own reports
    editTimeReport: ['custom'], // self
    startTimer: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    editTimer: ['owner', 'super admin', 'manager', 'custom'], // own reports
    removeTimer: ['owner', 'super admin', 'manager', 'custom'], // own reports

    // Common
    canPlayTour: ['owner', 'super admin', 'manager', 'regular']
};

const permissionTypeExists = (permissionType) => {
    if (!(permissionType in permissions)) {
        console.error(`Permissions Service: illegal permission type: ${permissionType}`);

        return false;
    }

    return true;
}

export const canUser = (permissionType, customList, user = getCurrentUser()) => {
    if (!permissionTypeExists(permissionType)) {
        return false;
    }

    if (!user) {
        return false;
    }

    if (customList && permissions[permissionType].includes('custom') && customList.includes(user.id)) {
        return true;
    }

    return permissions[permissionType].includes(user.role);
}
